module.exports = __webpack_public_path__ + "img/overall.ece13711.png";